import React from 'react';

// INFO TABS
import GameStore from './GameStore/GameStore';
import StateManagerView from './StateManagerView/StateManagerView';
import PhaserStates from './PhaserStatus/PhaserStatus';
import HttpResponse from './HttpResponse/HttpResponse';
import LoggerStatus from './LoggerStatus/LoggerStatus';

// TEST TABS
import Winlines from './Winlines/Winlines';
import MessageTest from './MessageTest/MessageTest';
import WinMessages from './WinMessages/WinMessages';
import Symbols from './Symbols/Symbols';
import Fixes from './Fixes/Fixes';
import Sound from './Sound/Sound';
import Timer from './Timer/Timer';
import JackpotCasino from './JackpotCasino/JackpotCasino';

const DevPanes = [
    {
        id: 0,
        title: 'Phaser',
        content: <PhaserStates />
    },
    {
        id: 1,
        title: 'States',
        content: <StateManagerView />
    },
    {
        id: 2,
        title: 'Response',
        content: <HttpResponse />
    },
    {
        id: 3,
        title: 'GameStore',
        content: <GameStore />
    },
    {
        id: 4,
        title: 'Jackpot',
        content: <JackpotCasino />
    },
    {
        id: 5,
        title: 'Logger',
        content: <LoggerStatus />
    }
];

export const Panes = DevPanes;

export const TestPanes = [
    {
        id: 0,
        title: 'Fixes',
        content: <Fixes />
    },
    /* {
        id: 1,
        title: 'Messages',
        content: <MessageTest />
    },
    {
        id: 2,
        title: 'Winlines',
        content: <Winlines />
    },*/
    {
        id: 1,
        title: 'Wins',
        content: <WinMessages />
    },
    /*{
        id: 4,
        title: 'Symbols',
        content: <Symbols />
    },
    {
        id: 5,
        title: 'Sound',
        content: <Sound />
    },*/
    {
        id: 2,
        title: 'Timer',
        content: <Timer />
    }
];
